// Limits shared by both profile forms. Optional fields are checked when filled.
export const PROFILE_FIELD_LIMITS = {
  firstName: { label: "First name", min: 3, max: 25 },
  middleName: { label: "Middle name", min: 3, max: 25 },
  lastName: { label: "Last name", min: 3, max: 25 },
  personalEmail: { label: "Personal email", min: 5, max: 155 },
  workEmail: { label: "Work email", min: 5, max: 155 },
  mobileNumber: { label: "Mobile number", min: 7, max: 15 },
  pincode: { label: "Pincode", min: 6, max: 6 },
  otherCountry: { label: "Other country", min: 3, max: 55 },
  city: { label: "City", min: 3, max: 55 },
  mailingAddress: { label: "Mailing address", min: 3, max: 155 },
  jobTitle: { label: "Job title", min: 3, max: 55 },
  jobResponsibility: { label: "Job responsibility", min: 3, max: 155 },
  hqLocation: { label: "Headquarters location", min: 3, max: 55 },
  companyLinkedIn: { label: "Company LinkedIn page", min: 3, max: 155 },
  otherCompany: { label: "Other company", min: 3, max: 155 },
  otherSector: { label: "Other sector", min: 3, max: 55 },
  otherIndustry: { label: "Other industry", min: 3, max: 55 },
  aboutCompany: { label: "About company", min: 10, max: 500 },
  employerCompanyName: { label: "Previous employer name", min: 3, max: 155 },
  employerJobTitle: { label: "Previous job title", min: 3, max: 55 },
  employerLocation: { label: "Previous employer location", min: 3, max: 55 },
  employerDescription: { label: "Previous job description", min: 10, max: 500 },
};

export const profileFieldLengthError = (field, value) => {
  const rule = PROFILE_FIELD_LIMITS[field];
  if (!rule || !String(value ?? "").trim()) return "";
  const length = String(value).trim().length;
  if (length < rule.min) return `${rule.label} must be at least ${rule.min} characters.`;
  if (length > rule.max) return `${rule.label} must be no more than ${rule.max} characters.`;
  return "";
};
